<div class="mode-label">{{ getExpressionMode() }}</div>
<div class="container-right">
    <button type="button" class="btn btn-secondary mr-20px size-s" (click)="onCancel()">
        Cancel
    </button>
    <button type="button" class="btn btn-primary size-s" (click)="onApply()">
        Apply
    </button>
</div>
